<template>
  <div>
    <!-- Chart Criteria -- Start -->      
    <div v-if="!display" class="container pt-2">
      <chart-criteria-skeleton />
    </div>
    <div v-if="display" class="container pt-2">      
      <div v-if="display" class="show-hide-links">
        <div class="col-4 mt-2 pl-0">
          <div class="chart-segment-options">
            <modal-link modal-id="Period/Group Options" :content-list="pageContent"></modal-link>
            <a href="#" v-show="!displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Show Period/Group Options<i class="fa fa-chevron-down ml-1"></i></a>
            <a href="#" v-show="displayChartCriteriaPeriod" @click="toggleChartCriteriaPeriod">Hide Period/Group Options<i class="fa fa-chevron-up ml-1"></i></a>
          </div>
        </div>
        <div class="col-3 mt-2">
          <div class="chart-segment-options">
            <modal-link modal-id="Analytics Options" :content-list="pageContent"></modal-link>
            <a href="#" v-show="!displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Show Analytics Options<i class="fa fa-chevron-down ml-1"></i></a>
            <a href="#" v-show="displayChartCriteriaAnalytics" @click="toggleChartCriteriaAnalytics">Hide Analytics Options<i class="fa fa-chevron-up ml-1"></i></a>
          </div>
        </div>
        <div class="col-5 mt-2">
          <div class="chart-segment-options">
            <modal-link modal-id="Segment Options" :content-list="pageContent"></modal-link>
            <a href="#" v-show="!displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Show Segment Options<i class="fa fa-chevron-down ml-1"></i></a>
            <a href="#" v-show="displayChartCriteriaSegments" @click="toggleChartCriteriaSegments">Hide Segment Options<i class="fa fa-chevron-up ml-1"></i></a>
          </div>
        </div>
      </div>
      <div v-if="display" class="form-row">
        <div class="col-4 mt-2 chart-criteria-border pl-0">
          <div v-show="displayChartCriteriaPeriod" class="w-100">
            <div class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <label for="companyId" class="sub-heading-label">Company</label>
              </div>
              <div class="chart-criteria-field-column">            
                  <select
                    id="companyId"
                    name="companyId"
                    class="custom-select shadow w-100"
                    :disabled="disableChartCriteriaWidgets"
                    v-on:change="resetDefaultMetricGroupId();"
                    v-model="companyId"
                  >
                    <option value="0">{{  clientName }}</option>
                    <option v-for="(option, idxCompanyOptions) in company_options" v-bind:value="option.value" v-bind:key="idxCompanyOptions">
                      {{ option.name }}
                    </option>
                  </select>
              </div>
            </div>  
            <div class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <label for="metricGroupId" class="sub-heading-label">Primary Axis</label>
              </div>
              <div class="chart-criteria-field-column">            
                  <select id="metricGroupId" v-model="metricGroupId" name="metricGroupId" class="shadow custom-select w-100" @change="clearMetricsTable($event,1)">
                    <option
                      v-for="(option, idxMetricGroupIdOptions) in this.primary_metric_options"
                      v-bind:value="option.value"
                      v-bind:key="idxMetricGroupIdOptions"
                      v-bind:selected="metricGroupId == option.value"
                    >
                      {{ option.name }}
                    </option>
                  </select>              
                </div>
            </div>
            <div class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                  <label for="secondaryMetricGroupId" class="sub-heading-label">Secondary Axis</label>
              </div>
              <div class="chart-criteria-field-column">
                <select id="secondaryMetricGroupId" v-model="secondaryMetricGroupId" name="secondaryMetricGroupId" class="custom-select shadow w-100" @change="clearMetricsTable($event,2)">
                  <option value="-1">None</option>
                  <option
                    v-for="(option, idxMetricGroupIdOptions) in this.secondary_metric_options"
                    v-bind:value="option.value"
                    v-bind:key="idxMetricGroupIdOptions"
                    v-bind:selected="secondaryMetricGroupId == option.value"
                  >
                    {{ option.name }}
                  </option>
                </select>              
              </div>
            </div>
            <div class="chart-criteria-row pb-2">
            <div class="chart-criteria-label-column">
                <label for="additionalSecondaryMetricGroupIds" class="sub-heading-label">Secondary Axis Additional Metrics</label>
            </div>
            <div class="chart-criteria-field-column shadow w-100">
              <multiselect
                ref="additionalSecondaryMetric"
                :disabled="disableSecondaryAxisAdditionalMetricDropdown"
                v-model="selectedAdditionalSecondaryMetrics"
                :options="additional_secondary_metric_options"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :max-height="1250"
                select-label=""
                deselect-label=""
                selected-label=""
                placeholder="None"
                label="name"
                name="additional_secondary_metrics"
                track-by="value"  
                @select="addAdditionalSecondaryMetric"
                @remove="removeAdditionalSecondaryMetric" 
                :preselect-first="false"
              >
                <template #option="props">
                  <span class="checkbox-label" @click.self="select(props.option)">
                    <input name="additional_secondary_metrics" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                    {{ props.option.name }}
                  </span>
                </template>
              </multiselect>
            </div>
            </div>
            <div class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <label for="startPeriod" class="sub-heading-label pt-2 my-auto">Start Period</label>
              </div>
              <div class="chart-criteria-field-column d-flex no-gutters">
                <div class="custom-select-fixed-width shadow">
                  <v-select
                    id="periodId"
                    name="periodId"
                    :options="period_options"
                    :reduce="period_option => period_option.clientTimePeriodId"
                    label="chartDisplayName"
                    :clearable="false"
                    v-model="startPeriod"
                  >
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes" class="custom-arrow"></span>
                    </template>
                  </v-select>
                </div>
                <div class="col-3 pl-2 pr-1">
                  <label for="endPeriod" class="sub-heading-label pt-2 my-auto">End Period</label>
                </div>
                <div class="custom-select-fixed-width">
                  <div class="w-100 shadow">
                    <v-select
                      id="periodId"
                      name="periodId"
                      :options="period_options"
                      :reduce="period_option => period_option.clientTimePeriodId"
                      label="chartDisplayName"
                      :clearable="false"
                      v-model="endPeriod"
                    >
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes" class="custom-arrow"></span>
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="chart-criteria-row">
            </div>
            <div class="chart-criteria-row">
              <div class="chart-criteria-label-column">
                <!--
                <modal-link modal-id="Survey Group" :content-list="pageContent"></modal-link>
                -->
                <label for="surveyGroup" class="sub-heading-label">Group</label>
              </div>
              <div class="chart-criteria-field-column">
                <select
                  id="surveyGroup"
                  name="surveyGroup"
                  class="custom-select shadow w-100"
                  :disabled="disableChartCriteriaWidgets"
                  v-on:change="saveValue($event, 'Survey Group', 'survey_group', true);setUseEqualWeight();"
                  v-model="surveyGroup"
                >
                  <option value="">None</option>
                  <option v-for="(option, idxSurveyGroupOptions) in survey_group_options" v-bind:value="option.value" v-bind:key="idxSurveyGroupOptions">
                    {{ option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="chart-criteria-row">  
              <div class="chart-criteria-label-column"></div>
              <div class="chart-criteria-field-column">
                <div class="form-group">
                  <input 
                    id="showPublicGroups" 
                    name="showPublicGroups" 
                    type="checkbox" 
                    true-value="Y" 
                    false-value="N" 
                    v-model="$parent.showPublicGroups" 
                    @click="saveCheckboxValue($event, 'Show Public Groups', 'show_public_groups', true)"
                    />
                  <span class="ml-1 mr-1">Show Public Groups</span>
                </div>    
                <div class="form-group">
                    <input
                      id="includePartialResponses"
                      name="includePartialResponses"
                      type="checkbox"
                      true-value="Y"
                      false-value="N"
                      v-model="includePartialResponses"
                      @click="saveCheckboxValue($event, 'Include Partial Responses', 'include_partial_responses', true)"
                    />
                    <span class="ml-1 mr-1">Include Partial Responses</span>
                </div>
                <div class="form-group">
                      <input 
                        id="useEqualWeight" 
                        name="useEqualWeight" 
                        type="checkbox" 
                        true-value="Y" 
                        false-value="N"
                        :disabled="disableEqualWeight" 
                        v-model="useEqualWeight" 
                        @click="saveCheckboxValue($event, 'Calculate Surveys Equal-Weighted', 'use_equal_weight', true)"
                        />
                      <span class="ml-1 mr-1">Calculate Surveys Equal-Weighted</span>
                </div>                               
              </div>
            </div>
          </div>
        </div>
        <div class="col-3 mt-2 chart-criteria-border">
          <div v-show="displayChartCriteriaAnalytics" class="w-100">
            <div class="d-flex m-1">
              <label for="relationShipStrength" class="sub-heading-label mr-2 mt-2">Relative Strength</label>
            </div>
            <div class="d-flex m-1">
              <div class="very-strong-correlation-square border"></div>
              <div v-if="isPositiveCorrelation" class="pl-2 align-self-center">Strong+ Correlation (0.8 to 1.0)</div>
              <div v-else class="pl-2 align-self-center">Strong+ Correlation (-0.8 to -1.0)</div>
            </div>
            <div class="d-flex m-1">
              <div class="strong-correlation-square border"></div>
              <div v-if="isPositiveCorrelation" class="pl-2 align-self-center">Strong Correlation (0.5 to 0.79)</div>
              <div v-else class="pl-2 align-self-center">Strong Correlation (-0.5 to -0.79)</div>
            </div>
            <div class="d-flex m-1">
              <div class="mild-correlation-square border"></div>
              <div v-if="isPositiveCorrelation" class="pl-2 align-self-center">Mild Correlation (0.3 to 0.49)</div>
              <div v-else class="pl-2 align-self-center">Mild Correlation (-0.3 to -0.49)</div>
            </div>
            <div class="d-flex m-1">
              <div class="no-correlation-square border"></div>
              <div v-if="isPositiveCorrelation" class="pl-2 align-self-center">No Correlation (Below 0.3 or negative)</div>
              <div v-else class="pl-2 align-self-center">No Correlation (Above -0.3 or positive)</div>
            </div>
          </div>            
        </div>
        <div class="col-5 mt-2">
          <div v-if="display && displayChartCriteriaSegments" class="segments row no-gutters">
            <div v-for="(chartCriteria, idxSegments) in segments" v-bind:key="idxSegments" class="col-lg-6 col-sm-12 pt-1 pb-1">
              <chart-criteria-option
                placeholder="Select"
                option-type="multiselect"
                label-class="sub-heading-label"
                v-bind:option-object="chartCriteria"
                :resetOption="resetOption"
                :chartTitle="chart.title"
                :surveyName="survey.name"
                :content-list="pageContent"
                @add="saveResultValue"
              ></chart-criteria-option>
            </div>
            <div class="d-none col-lg-4 col-sm-12">
              <div class="form-group">
                <!--
                <modal-link modal-id="Location" :content-list="pageContent"></modal-link>
                -->
                <label for="survey_location" class="control-label pt-1 pr-1 my-auto">Location</label>
                <a class="mr-1" href="#" @click="showPopup">
                  (Click to View Counts)                        
                </a>
                <treeselect
                  v-model="surveyLocation"
                  :multiple="true"
                  :alwaysOpen="false"
                  :show-count="false"
                  :default-expand-level="1"
                  :options="survey_location_options"
                  :append-to-body="true"
                  :required="false"
                  :clearable="false"
                  :maxHeight="400"
                  name="survey_location"
                  placeholder="Select"
                />
              </div>
            </div>
            <div class="col-lg-6 col-sm-12 pt-1 pb-1">
              <div class="d-none chart-criteria-row">
                  <div class="chart-criteria-label-column">
                    <label for="word" class="" style="color: #2f5eb3">Word</label>
                  </div>
                  <div class="col-9">
                    <Treeselect
                          :model-value="words"
                          @update:modelValue="onInputWords"
                          :is-independent-nodes="true"
                          :is-single-select="false"
                          :alwaysOpen="false"
                          :show-count="false"
                          :default-expand-level="1"
                          :options="word_options"
                          :append-to-body="true"
                          :required="false"
                          :clearable="false"
                          :maxHeight="400"
                          name="word"
                          placeholder="Select"
                        />
                  </div>
              </div>
            </div>                  
          </div>
        </div>
      </div>
    </div>
    <!-- Chart Criteria -- End -->
  </div>
</template>
<script>
import ChartCriteriaMixins from "../../mixins/ChartCriteriaMixins.vue";
import ContentMixins from "../../mixins/ContentMixins.vue";
import ChartCriteriaOption from "./ChartCriteriaOption.vue";
import ChartCriteriaSkeleton from "../skeleton/ChartCriteriaSkeleton.vue";
import Treeselect from "vue-treeselectjs";
import "vue-treeselectjs/dist/vue-treeselectjs.css";
import Multiselect from "vue-multiselect";

const parentProperties = [
  "display",
  "pageContent",
  "displayChartCriteriaPeriod",
  "displayChartCriteriaAnalytics",
  "displayChartCriteriaSegments",
  "companyId",
  "disableChartCriteriaWidgets",
  "clientName",
  "company_options",
  "metricGroupId",
  "primary_metric_options",
  "secondaryMetricGroupId",
  "secondary_metric_options",
  "disableSecondaryAxisAdditionalMetricDropdown",
  "selectedAdditionalSecondaryMetrics",
  "additional_secondary_metric_options",
  "period_options",
  "startPeriod",
  "endPeriod",
  "surveyGroup",
  "survey_group_options",
  "includePartialResponses",
  "useEqualWeight",
  "disableEqualWeight",
  "isPositiveCorrelation",
  "segments",
  "resetOption",
  "chart",
  "survey",
  "surveyLocation",
  "survey_location_options",
  "words",
  "word_options"
];

export default {
  name: "ChartCriteriaPredictive",
  mixins: [ContentMixins, ChartCriteriaMixins],
  components: {
    ChartCriteriaOption,
    ChartCriteriaSkeleton,
    Treeselect,
    Multiselect
  },
  created() {
    parentProperties.forEach(propertyName => {
      Object.defineProperty(this, propertyName, {
        configurable: true,
        get: () => this.$parent[propertyName],
        set: value => {
          this.$parent[propertyName] = value;
        }
      });
    });
  },
  methods: {
    resetDefaultMetricGroupId() {
      return this.$parent.resetDefaultMetricGroupId();
    },
    clearMetricsTable(event, tableType) {
      return this.$parent.clearMetricsTable(event, tableType);
    },
    addAdditionalSecondaryMetric(metric) {
      return this.$parent.addAdditionalSecondaryMetric(metric);
    },
    removeAdditionalSecondaryMetric(metric) {
      return this.$parent.removeAdditionalSecondaryMetric(metric);
    },
    toggleChartCriteriaPeriod() {
      return this.$parent.toggleChartCriteriaPeriod();
    },
    toggleChartCriteriaAnalytics() {
      return this.$parent.toggleChartCriteriaAnalytics();
    },
    toggleChartCriteriaSegments() {
      return this.$parent.toggleChartCriteriaSegments();
    },
    saveValue(...args) {
      return this.$parent.saveValue(...args);
    },
    saveCheckboxValue(...args) {
      return this.$parent.saveCheckboxValue(...args);
    },
    saveResultValue(...args) {
      return this.$parent.saveResultValue(...args);
    },
    setUseEqualWeight() {
      return this.$parent.setUseEqualWeight();
    },
    showPopup() {
      return this.$parent.showPopup();
    },
    onInputWords(value) {
      return this.$parent.onInputWords(value);
    },
    select(option) {
      option.checked = !option.checked;
    }
  }
};
</script>
